import React, { Component } from "react";
import { Modal, Button } from "react-bootstrap";

// Estilos para el modal personalizado
const customModalStyles = {
  overlay: {
    modal90w: {
      maxWidth: "550px",
      width: "95%",
      margin: "0 auto",
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
    modalHeader: {
      border: "none",
      textAlign: "center",
      paddingBottom: 0,
    },
    modalContent: {
      borderRadius: "12px",
      border: "none",
    },
    dataBox: {
      backgroundColor: "#f8f9fa",
      borderRadius: "10px",
      padding: "25px",
      boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
      marginBottom: "25px",
      border: "1px solid #eee",
    },
  },
};

const customStyles = `
  .custom-modal-dialog {
    display: flex !important;
    align-items: center;
    justify-content: center;
    min-height: calc(100% - 1rem);
  }
  
  .custom-modal-dialog .modal-content {
    width: 550px;
    max-width: 95%;
    border-radius: 12px;
    border: none;
    margin: auto;
  }
`;

class ModalConfirmacion extends Component {
  componentDidMount() {
    const styleElement = document.createElement("style");
    styleElement.innerHTML = customStyles;
    document.head.appendChild(styleElement);
  }

  componentWillUnmount() {
    const styleElements = document.querySelectorAll("style");
    for (let i = 0; i < styleElements.length; i++) {
      if (styleElements[i].innerHTML === customStyles) {
        document.head.removeChild(styleElements[i]);
        break;
      }
    }
  }

  render() {
    const {
      show,
      onHide,
      onConfirm,
      opcion,
      fields,
      bancos,
      cuentas,
      cuentas_be
    } = this.props;

    // Verificamos que los props necesarios existan
    if (!show || opcion === null || !fields || !Array.isArray(fields)) {
      return null;
    }

    // Datos del banco seleccionado
    const selectedFields = fields[opcion] || null;

    // Si no hay campos seleccionados, no renderizamos
    if (!selectedFields) {
      return null;
    }

    const tipoCuenta = selectedFields.tipo_cuenta || '';
    const numeroCuenta = selectedFields.cuenta || 'xx.xxx.xxx-x';
    const bancoCodigo = opcion !== 0 ? selectedFields.banco || '' : '';
    
    // Obtenemos el nombre del banco y tipo de cuenta de forma segura
    let nombreBanco = "Banco Estado";
    if (opcion !== 0) {
      nombreBanco = bancos && Array.isArray(bancos) && bancoCodigo
        ? bancos.find(b => b.value === bancoCodigo)?.label || ""
        : "";
    }
    
    let nombreTipoCuenta = "";
    if (opcion === 0) {
      nombreTipoCuenta = cuentas_be && Array.isArray(cuentas_be) && tipoCuenta
        ? cuentas_be.find(c => c.value === tipoCuenta)?.label || ""
        : "";
    } else {
      nombreTipoCuenta = cuentas && Array.isArray(cuentas) && tipoCuenta
        ? cuentas.find(c => c.value === tipoCuenta)?.label || ""
        : "";
    }

    return (
      <Modal
        show={show}
        onHide={onHide}
        centered
        backdrop="static"
        keyboard={false}
        size="lg"
        dialogClassName="custom-modal-dialog"
        contentClassName="rounded-lg"
        style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh" }}
      >
        <Modal.Body className="p-4" style={{ borderRadius: "12px", overflowY: "auto" }}>
          <div className="text-center mb-4">
            <h4 className="font-weight-bold" style={{ color: "#333" }}>
              Confirmación de datos
            </h4>
          </div>

          <div
            className="bg-light p-3 mb-4 text-center"
            style={customModalStyles.overlay.dataBox}
          >
            <h5 className="font-weight-bold mb-3" style={{ color: "#444" }}>
              {nombreBanco}
            </h5>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "17px",
                  color: "#555",
                  marginBottom: "6px",
                }}
              >
                {nombreTipoCuenta}
              </span>
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "bold",
                  color: "#333",
                }}
              >
                N°{" "}
                {numeroCuenta}
              </span>
            </div>
          </div>

          <div className="text-center mb-4">
            <p style={{ fontSize: "16px", lineHeight: "1.6", color: "#555" }}>
              Estos son los datos ingresados, donde recibirás el abono de tu
              rescate de ahorro, ¿estás seguro que se encuentran correctos?
            </p>
            <p
              className="font-weight-bold"
              style={{ fontSize: "16px", color: "#333" }}
            >
              ¿Desea continuar con el retiro?
            </p>
          </div>

          <div className="d-flex justify-content-center align-items-center mt-4 px-4" style={{ flexWrap: "wrap" }}>
            <Button
              variant="light"
              onClick={onHide}
              className="px-4 py-2 mx-2 my-2"
              style={{
                borderRadius: "25px",
                minWidth: "120px",
                fontWeight: "500",
                border: "1px solid #ddd",
                boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
              }}
            >
              Cancelar
            </Button>
            <Button
              variant="warning"
              onClick={onConfirm}
              className="px-4 py-2 mx-2 my-2"
              style={{
                borderRadius: "25px",
                minWidth: "120px",
                fontWeight: "500",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              }}
            >
              Aceptar
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ModalConfirmacion; 